<template>
  <v-dialog v-model="dialogComputed" scrollable>
    <v-card>
      <v-card-title class="primary white--text py-2" primary-title>
        {{ $t('ELE0504') }}
        <v-spacer />
        <Btn icon="mdi-close" @click="close" depressed iconProp color="white" />
      </v-card-title>
      <v-card-text>
        <v-container fluid class="px-1">
          <v-row>
            <v-col>
              <TextFieldRef :label="$t('ELE0059')" cols="4" v-model="part" />
            </v-col>
            <v-col>
              <TextFieldRef :label="$t('ELE0134')" cols="4" v-model="supplier" />
            </v-col>
            <v-spacer />
          </v-row>
          <v-row>
            <v-col>
              <v-card outlined>
                <v-card-title>
                  {{ $t('ELE0188') }}
                </v-card-title>
                <!-- 初期では10行表示されてBasic Infoが見えづらいため、items-per-pageを設定 -->
                <v-data-table :headers="inspResultsHeaders" :items="inspResultsItems" dense :items-per-page="5">
                  <template v-slot:[`item.repInspPart`]="{ item }">
                    {{ `${item.repInspPartCd} : ${item.partName}` }}
                  </template>
                  <template v-slot:[`item.itemUpdatedBy`]="{ item }">
                    {{ `${item.itemUpdatedBy} : ${item.userName}` }}
                  </template>
                  <template v-slot:[`item.itemUpdatedAt`]="{ item }">
                    {{ toLocalTime(item.itemUpdatedAt) }}
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card outlined>
                <v-card-title>
                  {{ $t('ELE0523') }}
                </v-card-title>
                <!-- 初期では10行表示されてBasic Infoが見えづらいため、items-per-pageを設定 -->
                <v-data-table :headers="basicInfoHeaders" :items="basicInfoItems" dense :items-per-page="5">
                  <template v-slot:[`item.isRequiredXrf`]="{ item }">
                    {{ $t('IsRequiredXrf.' + item.isRequiredXrf) }}
                  </template>
                  <template v-slot:[`item.xrfInspCycle`]="{ item }">
                    <td class="v-data-table__divider text-right">
                      {{ item.xrfInspCycle }}
                    </td>
                  </template>
                  <template v-slot:[`item.inspQty`]="{ item }">
                    <td class="v-data-table__divider text-right">
                      {{ item.inspQty }}
                    </td>
                  </template>
                  <template v-slot:[`item.inspDeptCd`]="{ item }">
                    {{ item.inspDeptCd ? `${item.inspDeptCd} : ${item.inspDeptName}` : '' }}
                  </template>
                  <template v-slot:[`item.processCd`]="{ item }">
                    {{ item.processCd ? `${item.processCd} : ${$t('XrfPostProcessingCd.' + item.processCd)}` : '' }}
                  </template>
                  <template v-slot:[`item.isValid`]="{ item }">
                    {{ $t('isValid.' + item.isValid) }}
                  </template>
                  <template v-slot:[`item.itemUpdatedBy`]="{ item }">
                    {{ `${item.itemUpdatedBy} : ${item.userName}` }}
                  </template>
                  <template v-slot:[`item.itemUpdatedAt`]="{ item }">
                    {{ toLocalTime(item.itemUpdatedAt) }}
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'

import Btn from '@/components/atoms/base/button/Btn'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'

export default {
  name: 'XrfHistoryDialog',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    Btn,
    TextFieldRef,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    partCd: {
      type: String,
      required: true,
    },
    manufacturerCd: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      part: '',
      supplier: '',
      inspResultsHeaders: [
        { text: this.$t('ELE0138'), value: 'xrfInspDate', divider: true },
        { text: this.$t('ELE0254'), value: 'xrfExpiredDate', divider: true },
        { text: this.$t('ELE0525'), value: 'repInspPart', divider: true },
        { text: this.$t('ELE0054'), value: 'remarks', divider: true },
        { text: this.$t('ELE0039'), value: 'itemUpdatedBy', divider: true },
        { text: this.$t('ELE0030'), value: 'itemUpdatedAt' },
      ],
      inspResultsItems: [],
      basicInfoHeaders: [
        { text: this.$t('ELE0519'), value: 'xrfGroupName', divider: true },
        { text: this.$t('ELE0524'), value: 'isRequiredXrf', divider: true },
        { text: this.$t('ELE0214'), value: 'xrfInspCycle', divider: true },
        { text: this.$t('ELE0532'), value: 'inspQty', divider: true },
        { text: this.$t('ELE0533'), value: 'inspDeptCd', divider: true },
        { text: this.$t('ELE0534'), value: 'processCd', divider: true },
        { text: this.$t('ELE0014'), value: 'isValid', divider: true },
        { text: this.$t('ELE0039'), value: 'itemUpdatedBy', divider: true },
        { text: this.$t('ELE0030'), value: 'itemUpdatedAt' },
      ],
      basicInfoItems: [],
    }
  },

  watch: {
    dialog() {
      if (this.dialog) {
        this.search()
      }
    },
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },

  methods: {
    close() {
      this.dialogComputed = false
    },
    async search() {
      try {
        this.startLoading()
        const params = {
          partCd: this.partCd,
          manufacturerCd: this.manufacturerCd,
        }
        const element = await API.get('/xrfs/history', params)
        this.part = `${this.partCd} : ${element.partName}`
        this.supplier = `${this.manufacturerCd} : ${element.manufacturerName}`
        this.inspResultsItems = element['inspResultsList']
        this.basicInfoItems = element['basicInfoList']
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0529') })))
      } finally {
        this.stopLoading()
      }
    },
  },
  mounted() {
    this.search()
  },
}
</script>
